import React from "react";
import AlbumRelease from "./AlbumRelease";
import Starfield from "./Starfield";

function App() {
  return (
    <>
      <Starfield />
      <AlbumRelease />
    </>
  );
}

export default App;
